import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=d817c8c6&scoped=true"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=d817c8c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d817c8c6",
  null
  
)

export default component.exports